import React from 'react';
import { StyledStatus, StyledStatusText } from '@/components/common/statuses/status.styled';
import {
  IconCheck,
  IconCompleteCircle,
  IconErrorCircle,
  IconCircleOutlined,
  IconWarning
} from '@mzc-cloudplex/icons';
import { PURGE_JOB_STATUSES } from '@/services/job/purgeJobService';
import theme from '@/styles/theme';
import { Typography } from '@mui/material';
import { CircleProgress } from '@packages/legacy-ui';
import { useTranslation } from 'react-i18next';

const PurgeStatus = ({ status }) => {
  const { t } = useTranslation('jobs');
  return (
    <>
      {status === PURGE_JOB_STATUSES.PREPARED && <StyledStatus label={t('prepared')} />}
      {status === PURGE_JOB_STATUSES.ALL_FAILED && (
        <StyledStatus
          label={t('error')}
          color={'error'}
          icon={<IconWarning size={12} htmlColor={'#fff'} />}
        />
      )}
      {status === PURGE_JOB_STATUSES.INCLUDE_FAILED && (
        <>
          <StyledStatus
            label={t('completed')}
            color={'success'}
            icon={<IconCheck size={12} htmlColor={'#fff'} />}
          />
          <IconErrorCircle size={16} color={'error'} />
        </>
      )}
      {status === PURGE_JOB_STATUSES.IN_PROGRESS && (
        <StyledStatus label={t('inProgress')} color={'primary'} />
      )}
      {status === PURGE_JOB_STATUSES.COMPLETED && (
        <StyledStatus
          label={t('completed')}
          color={'success'}
          icon={<IconCheck size={12} htmlColor={'#fff'} />}
        />
      )}
    </>
  );
};

export const PurgeTextStatus = ({ status }) => {
  const { t } = useTranslation('jobs');
  return (
    <>
      {status === PURGE_JOB_STATUSES.PREPARED && (
        <StyledStatusText>
          <IconCircleOutlined size={12} htmlColor={theme.palette.grayscaleSecondary[300]} />
          <Typography color={theme.palette.grayscaleSecondary[300]}>{t('prepared')}</Typography>
        </StyledStatusText>
      )}
      {status === PURGE_JOB_STATUSES.ALL_FAILED && (
        <StyledStatusText>
          <IconErrorCircle size={12} color={'error'} />
          <Typography color={theme.palette.error.main}>{t('failed')}</Typography>
        </StyledStatusText>
      )}
      {status === PURGE_JOB_STATUSES.INCLUDE_FAILED && (
        <>
          <StyledStatusText>
            <IconCompleteCircle size={12} color={'success'} />
            <Typography color={theme.palette.success.main}>{t('completed')}</Typography>
            <IconErrorCircle size={12} color={'error'} />
          </StyledStatusText>
        </>
      )}
      {status === PURGE_JOB_STATUSES.IN_PROGRESS && (
        <StyledStatusText>
          <CircleProgress size={12} color={'primary'} thickness={5} />
          <Typography color={theme.palette.primary.main}>{t('inProgress')}</Typography>
        </StyledStatusText>
      )}
      {status === PURGE_JOB_STATUSES.COMPLETED && (
        <StyledStatusText>
          <IconCompleteCircle size={12} color={'success'} />
          <Typography color={theme.palette.success.main}>{t('completed')}</Typography>
        </StyledStatusText>
      )}
    </>
  );
};

export default PurgeStatus;
